<template src="./Notification.html"></template>
<style src="./Notification.scss" lang="scss"></style>

<script>
	import Button from '@/components/Button/Button';
	import Icon from '@/components/Icon/Icon';

	/**
	 * Constants for supported types of notifications
	 */
	const NOTIFICATION_TYPES = {
		default: '',
		breakingNews: 'breakingNews',
		success: 'success'
	};

	/**
	 * The notification component is used to show errors, breaking news or other information.
	 * @vue-prop {('' | 'breakingNews' | 'success')} [type] the type (intent) of the notification
	 * @vue-prop {string} [icon] the name of the icon at the beginning
	 * @vue-prop {string} [highlight] the text at the beginning written in bold
	 * @vue-prop {string} [text] the main text of the notification
	 * @vue-prop {string} [url] the url if the notification should be link
	 * @vue-prop {{ url: '', icon: '', text: ''}} [button] show a button with an icon and text; when url is passed, rendered as link
	 * @vue-prop {bool} [canClose] enable close option
	 * @vue-computed {'primary' | 'ghost'} [buttonImportance] The color of the button mapped by importance
	 */
	export default {
		name: 'HpNotification',
		components: {
			'hp-button': Button,
			'hp-icon': Icon
		},
		data () {
			return {
				isVisible: true
			};
		},
		computed: {
			buttonImportance () {
				return process.env.VUE_APP_BRAND === 'einsundeins' && this.type === 'success' ? 'accent' : 'primary';
			}
		},
		props: {
			type: {
				type: String,
				required: false,
				default: NOTIFICATION_TYPES.default
			},
			icon: String,
			highlight: String,
			text: String,
			url: String,
			button: Object,
			canClose: Boolean
		},
		methods: {
			close () {
				this.isVisible = false;
			}
		}
	}
</script>
